<div [id]="id" class="common-dialog common-modal" [class.rtl]="isRTL">
  <div class="dialog-header">
    <div class="dialog-title">{{ title }}</div>
    <div class="dialog-close">
      <app-pencil-button
        class="pencil-button close-button"
        [attr.data-name]="id + '-close-button'"
        [icon]="'close'"
        [iconConfig]="{ type: 'mat-icon', outlined: true }"
        (clickEvent)="onClose()"
      >
      </app-pencil-button>
    </div>
  </div>

  <div class="dialog-body">
    <div class="dialog-content-query">
      <div class="filters-bar-container">
        <app-search-bar
          [attr.data-name]="id + '-search-bar'"
          [size]="SearchBarSizeEnum.LARGE"
          [searchTitle]="searchPlaceholder"
          [searchOnClear]="false"
          [blurOnSearch]="false"
          (filter)="onSearch($event)"
        ></app-search-bar>

        <div
          cdkOverlayOrigin
          #filtersButton="cdkOverlayOrigin"
          *ngIf="(filters | async)?.length"
          class="pencil-filters-button large"
          [ngClass]="{ active: isFiltersOpen }"
          (click)="toggleFiltersPanel()"
        >
          <app-pencil-icon name="tune" [type]="IconTypes.svgIcon"></app-pencil-icon>
          <div class="filters-badge" *ngIf="(appliedFilters$ | async)?.length as count">
            {{ count }}
          </div>
        </div>
      </div>
      <app-applied-filter-pills></app-applied-filter-pills>
    </div>

    <div class="dialog-content-header" *ngIf="sections.contentHeader">
      <ng-container *ngTemplateOutlet="sections.contentHeader"></ng-container>
    </div>

    <div class="dialog-disclaimer" *ngIf="sections.disclaimer">
      <app-pencil-icon
        name="info"
        [type]="IconTypes.materialIcon"
        [outlined]="true"
      ></app-pencil-icon>
      <div>
        <ng-container *ngTemplateOutlet="sections.disclaimer"></ng-container>
      </div>
    </div>

    <div #dialogContent class="dialog-content">
      <ng-container
        *ngTemplateOutlet="
          sections.content;
          context: { $implicit: { loading: loading, empty: empty } }
        "
      ></ng-container>
    </div>
  </div>

  <div class="dialog-footer" *ngIf="sections.footer">
    <ng-container *ngTemplateOutlet="sections.footer"></ng-container>
  </div>
</div>

<ng-template #loading>
  <ng-container *ngIf="isLoading$ | async">
    <app-content-loader [blockCount]="5"></app-content-loader>
  </ng-container>
</ng-template>

<ng-template #empty>
  <ng-container *ngIf="(isLoading$ | async) === false && (isEmpty$ | async)">
    <div class="blank-state">
      <span>{{ emptyMessage || ('No data found' | translate) }}</span>
    </div>
  </ng-container>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="filtersButton"
  [cdkConnectedOverlayOpen]="isFiltersOpen"
  [cdkConnectedOverlayPanelClass]="'filters-overlay-menu'"
  [cdkConnectedOverlayPositions]="[OverlayPositions.BOTTOM_RIGHT]"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
  (backdropClick)="toggleFiltersPanel()"
>
  <app-generic-filters-view
    [showFilterIcon]="false"
    [showCloseButton]="false"
    [showLastDivider]="false"
  ></app-generic-filters-view>
</ng-template>
